import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faUser, faPen, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const Support = () => {
  return (
    <div className="bg-white">
      <section className="bg-[#F0EFFA] p-6 md:p-10 text-center">
        <h1 className="text-2xl md:text-4xl font-bold mb-4 text-[#05004E]">Contact Us</h1>
        <p className="text-lg md:text-2xl mb-10 text-[#05004E]">
          Get in touch let us know how we can help
        </p>
        <div className="flex flex-wrap justify-center space-x-0 space-y-6 md:space-x-6 md:space-y-0 text-[#05004E]">
          <ContactCard title="Getting Started" icon={faPlane} />
          <ContactCard title="Get Support" icon={faUser} />
          <ContactCard title="Team & Billing" icon={faPen} />
          <ContactCard title="Troubleshooting" icon={faQuestionCircle} />
        </div>
      </section>
      <section className="p-6 md:p-10">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="md:w-1/2 mb-6 md:mb-0">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-[#05004E]">FAQs</h2>
            <p className="text-[#05004E] text-xl" style={{ maxWidth: '40ch' }}>
              Find answers to your questions about our services and support. Can't locate what you need? Reach out to our team via <a href="#" className="text-blue-500 underline">chat!</a>
            </p>
          </div>
          <div className="md:w-1/2 space-y-4">
            <FaqItem question="What documents can I certify?" answer="You can certify any digital document with TrustForge. This includes contracts, certificates, legal documents, and more. Our platform supports a wide range of file formats to meet your needs." />
            <FaqItem question="Why can't I upload my document?" answer="There could be several reasons why you can't upload your document. Ensure your file format is supported and that it doesn't exceed the maximum file size. If the issue persists, please contact support." />
            <FaqItem question="How do I reset my password?" answer="To reset your password, go to the login page and click on 'Forgot Password'. Follow the instructions sent to your email to reset your password securely." />
            <FaqItem question="How is my data protected?" answer="Your data is protected using advanced encryption methods. We also implement strict access controls and regular security audits to ensure your data remains safe and confidential." />
            <FaqItem question="Can I delete my account?" answer="Yes, you can delete your account. Go to your account settings and find the 'Delete Account' option. Please note that this action is irreversible and all your data will be permanently removed." />
          </div>
        </div>
      </section>
    </div>
  );
};

const ContactCard = ({ title, icon }) => {
  return (
    <div className="bg-blue-100 p-4 md:p-6 rounded-xl shadow-md flex flex-col items-center w-40 md:w-48 mx-2">
      <FontAwesomeIcon icon={icon} className="text-3xl md:text-4xl mb-4" />
      <h3 className="text-lg md:text-xl font-semibold text-center">{title}</h3>
    </div>
  );
};

const FaqItem = ({ question, answer }) => {
  return (
    <details className="cursor-pointer text-lg md:text-xl font-medium">
      <summary className="flex justify-between items-center p-4 rounded-md">
        <span className="text-gray-700">{question}</span>
        <span className="text-2xl text-gray-500">+</span>
      </summary>
      <p className="mt-2 ml-4 pl-4 text-gray-600">
      {answer}
      </p>
    </details>
  );
};

export default Support;
